var map = {
	"./1INCH.png": 1023,
	"./2BRZ.svg": 1024,
	"./2CAD.svg": 1025,
	"./2JPY.svg": 1026,
	"./2NZD.svg": 1027,
	"./2OMB.png": 1028,
	"./2SGD.png": 1029,
	"./2SHARES.png": 1030,
	"./3EPS.png": 1031,
	"./4EUR.png": 1032,
	"./AAVE.svg": 1033,
	"./AAVEe.svg": 1034,
	"./ACRE.png": 1035,
	"./ACX.png": 1036,
	"./ADA.png": 1037,
	"./ADX.svg": 1038,
	"./AELIN.webp": 1039,
	"./ALI.svg": 1040,
	"./ALICE.png": 1041,
	"./ALPACA.png": 1042,
	"./ALPHA.png": 1043,
	"./AMPL.png": 1044,
	"./ANKR.png": 1045,
	"./ANN.png": 1046,
	"./ANY.png": 1047,
	"./AOT.png": 1048,
	"./APE.png": 1049,
	"./ATLAS.png": 1050,
	"./ATOM.png": 1051,
	"./AURA.png": 1052,
	"./AURO.png": 1053,
	"./AURORA.svg": 1054,
	"./AVAX.png": 1055,
	"./AVAX.svg": 1056,
	"./AVAXL.svg": 1057,
	"./AXS.png": 1058,
	"./ApeUSD.svg": 1059,
	"./BABY.svg": 1060,
	"./BABYCAKE.svg": 1061,
	"./BAKE.png": 1062,
	"./BAL-WETH-80-20.png": 1063,
	"./BAL.svg": 1064,
	"./BALL.png": 1065,
	"./BANANA.png": 1066,
	"./BAPE.svg": 1067,
	"./BASED.svg": 1068,
	"./BAT.png": 1069,
	"./BCH.svg": 1070,
	"./BCT.png": 1071,
	"./BDO.png": 1072,
	"./BDP.png": 1073,
	"./BEAR.png": 1074,
	"./BEETS.png": 1075,
	"./BELT.png": 1076,
	"./BETA.svg": 1077,
	"./BETH.png": 1078,
	"./BETU.png": 1079,
	"./BHC.png": 1080,
	"./BICO.png": 1081,
	"./BIFI.png": 1082,
	"./BISON.png": 1083,
	"./BLZZ.svg": 1084,
	"./BMON.svg": 1085,
	"./BNB.png": 1086,
	"./BNBbsc.png": 1087,
	"./BNBx.png": 1088,
	"./BOMB.png": 1089,
	"./BOND.svg": 1090,
	"./BONE.png": 1091,
	"./BONEswap.png": 1092,
	"./BOO.png": 1093,
	"./BOOK.png": 1094,
	"./BORING.png": 1095,
	"./BP.png": 1096,
	"./BPT.png": 1097,
	"./BREW.png": 1098,
	"./BRIBE.png": 1099,
	"./BRUSH.png": 1100,
	"./BRZ.png": 1101,
	"./BRZw.png": 1102,
	"./BSC.svg": 1103,
	"./BSCDEFI.svg": 1104,
	"./BSCPAD.png": 1105,
	"./BSHARE.svg": 1106,
	"./BSTN.svg": 1107,
	"./BSW.svg": 1108,
	"./BTC.svg": 1109,
	"./BTCB.png": 1110,
	"./BTCB.svg": 1111,
	"./BTCST.png": 1112,
	"./BTD.png": 1113,
	"./BTS.png": 1114,
	"./BTT.png": 1115,
	"./BUNNY.png": 1116,
	"./BURGER.png": 1117,
	"./BUSD.png": 1118,
	"./BUSDe.svg": 1119,
	"./BUSDwh.svg": 1120,
	"./BUSM.png": 1121,
	"./BYTE.png": 1122,
	"./C98.png": 1123,
	"./CADC.png": 1124,
	"./CAI.png": 1125,
	"./CAKE.png": 1126,
	"./CAPS.svg": 1127,
	"./CARROT.png": 1128,
	"./CCAR.png": 1129,
	"./CEEK.png": 1130,
	"./CEL.png": 1131,
	"./CELO.svg": 1132,
	"./CELR.png": 1133,
	"./CHARGE.png": 1134,
	"./CHARM.svg": 1135,
	"./CHESS.svg": 1136,
	"./CHR.png": 1137,
	"./CLAM.png": 1138,
	"./CLY.png": 1139,
	"./COMB.png": 1140,
	"./COMP.png": 1141,
	"./CONE.png": 1142,
	"./COOK.png": 1143,
	"./COTI.png": 1144,
	"./CRA.png": 1145,
	"./CRAFT.png": 1146,
	"./CRE8R.png": 1147,
	"./CRO.svg": 1148,
	"./CRONA.svg": 1149,
	"./CRUSH.svg": 1150,
	"./CRV.png": 1151,
	"./CRYSTL.png": 1152,
	"./CSUSHI.png": 1153,
	"./CTK.png": 1154,
	"./CVX.png": 1155,
	"./CYT.png": 1156,
	"./CZF.png": 1157,
	"./DAI.png": 1158,
	"./DAI.svg": 1159,
	"./DAIe.png": 1160,
	"./DAIs.png": 1161,
	"./DAR.svg": 1162,
	"./DARK.svg": 1163,
	"./DBY.png": 1164,
	"./DCAU.png": 1165,
	"./DEG.png": 1166,
	"./DEI.png": 1167,
	"./DEI_OLD.png": 1168,
	"./DELIRIUM.png": 1169,
	"./DEP.png": 1170,
	"./DEUS.png": 1171,
	"./DFYN.png": 1172,
	"./DG.png": 1173,
	"./DIBS.png": 1174,
	"./DINO.png": 1175,
	"./DIS.svg": 1176,
	"./DKT.png": 1177,
	"./DOGE.svg": 1178,
	"./DOLA.svg": 1179,
	"./DOMI.png": 1180,
	"./DOT.png": 1181,
	"./DPI.png": 1182,
	"./DPT.png": 1183,
	"./DRUGS.png": 1184,
	"./DSHARE.png": 1185,
	"./DUET.svg": 1186,
	"./DVI.svg": 1187,
	"./DYST.png": 1188,
	"./ECD.png": 1189,
	"./EGG.png": 1190,
	"./ELK.png": 1191,
	"./ELON.png": 1192,
	"./EMP.png": 1193,
	"./EPS.png": 1194,
	"./ERA.svg": 1195,
	"./ERTHA.png": 1196,
	"./ESHARE.png": 1197,
	"./EST.png": 1198,
	"./ETC.png": 1199,
	"./ETERNAL.png": 1200,
	"./ETH.png": 1201,
	"./ETH.svg": 1202,
	"./ETH2x.png": 1203,
	"./ETHs.svg": 1204,
	"./ETHwh.svg": 1205,
	"./EURS.png": 1206,
	"./EURe.png": 1207,
	"./EURt.png": 1208,
	"./EXP.svg": 1209,
	"./EZ.png": 1210,
	"./FER.svg": 1211,
	"./FET.png": 1212,
	"./FFF.png": 1213,
	"./FIEF.png": 1214,
	"./FIL.svg": 1215,
	"./FINN.png": 1216,
	"./FIRA.svg": 1217,
	"./FIRE.png": 1218,
	"./FISH.png": 1219,
	"./FITFI.png": 1220,
	"./FLARE.png": 1221,
	"./FLX.png": 1222,
	"./FLY.png": 1223,
	"./FODL.png": 1224,
	"./FONT.png": 1225,
	"./FOO.png": 1226,
	"./FORM.svg": 1227,
	"./FOX.png": 1228,
	"./FRAX.png": 1229,
	"./FRAX.svg": 1230,
	"./FROYO.png": 1231,
	"./FRUIT.png": 1232,
	"./FS.png": 1233,
	"./FTM.png": 1234,
	"./FTML.svg": 1235,
	"./FUSE.svg": 1236,
	"./FXS.png": 1237,
	"./G.png": 1238,
	"./GAL.png": 1239,
	"./GEAR.png": 1240,
	"./GEIST.svg": 1241,
	"./GEL.png": 1242,
	"./GENESIS.png": 1243,
	"./GHST.png": 1244,
	"./GIDDY.png": 1245,
	"./GLINT.png": 1246,
	"./GLMR.png": 1247,
	"./GLP.svg": 1248,
	"./GM.png": 1249,
	"./GMT.svg": 1250,
	"./GMX.png": 1251,
	"./GMX.svg": 1252,
	"./GNS.png": 1253,
	"./GNT.png": 1254,
	"./GOLDCOIN.svg": 1255,
	"./GRAPE.png": 1256,
	"./GRT.png": 1257,
	"./GUARD.svg": 1258,
	"./HAI.png": 1259,
	"./HARD.png": 1260,
	"./HAY.svg": 1261,
	"./HBAR.png": 1262,
	"./HBTC.png": 1263,
	"./HDOT.png": 1264,
	"./HEC.png": 1265,
	"./HEC.svg": 1266,
	"./HERMES.svg": 1267,
	"./HERO.png": 1268,
	"./HFIL.png": 1269,
	"./HIGH.png": 1270,
	"./HND.png": 1271,
	"./HONEY.png": 1272,
	"./HONOR.png": 1273,
	"./HOOP.png": 1274,
	"./HOP.png": 1275,
	"./HOTCROSS.svg": 1276,
	"./HPS.png": 1277,
	"./HPT.png": 1278,
	"./HT.png": 1279,
	"./HTB.svg": 1280,
	"./HUM.svg": 1281,
	"./HUSD.png": 1282,
	"./ICA.svg": 1283,
	"./ICE.png": 1284,
	"./IDIA.svg": 1285,
	"./IF.svg": 1286,
	"./IME.png": 1287,
	"./INCH.png": 1288,
	"./INJ.png": 1289,
	"./INSUR.png": 1290,
	"./INV.png": 1291,
	"./IOTA.png": 1292,
	"./IOTX.png": 1293,
	"./IRON.png": 1294,
	"./IXT.png": 1295,
	"./JETS.png": 1296,
	"./JEWEL.png": 1297,
	"./JOE.png": 1298,
	"./JPYC.png": 1299,
	"./JRT.png": 1300,
	"./JULD.png": 1301,
	"./JUST.png": 1302,
	"./KAE.png": 1303,
	"./KART.png": 1304,
	"./KAVA.svg": 1305,
	"./KEBAB.png": 1306,
	"./KEK.png": 1307,
	"./KIRO.png": 1308,
	"./KLIMA.png": 1309,
	"./KLO.png": 1310,
	"./KRW.png": 1311,
	"./KWENTA.png": 1312,
	"./L2DAO.svg": 1313,
	"./LAC.svg": 1314,
	"./LAMBDA.svg": 1315,
	"./LAND.svg": 1316,
	"./LAZIO.png": 1317,
	"./LCD.png": 1318,
	"./LDO.png": 1319,
	"./LINEAR.svg": 1320,
	"./LINK.png": 1321,
	"./LINKe.png": 1322,
	"./LIQ.png": 1323,
	"./LITHIUM.svg": 1324,
	"./LONG.png": 1325,
	"./LOST.png": 1326,
	"./LTC.svg": 1327,
	"./LUNA.png": 1328,
	"./LUNAw.png": 1329,
	"./LUSD.svg": 1330,
	"./LYRA.webp": 1331,
	"./MAGIC.png": 1332,
	"./MAI.png": 1333,
	"./MAIA.svg": 1334,
	"./MAI_Rose.png": 1335,
	"./MANA.png": 1336,
	"./MARSH.png": 1337,
	"./MASK.svg": 1338,
	"./MATIC.png": 1339,
	"./MCB.png": 1340,
	"./MCRN.svg": 1341,
	"./MDX.png": 1342,
	"./MECHA.png": 1343,
	"./MELT.png": 1344,
	"./MERL.svg": 1345,
	"./METAHERO.svg": 1346,
	"./METIS.svg": 1347,
	"./MGP.png": 1348,
	"./MIDAS.png": 1349,
	"./MILK.png": 1350,
	"./MIM.png": 1351,
	"./MIX.png": 1352,
	"./MOBI.svg": 1353,
	"./MONEY.png": 1354,
	"./MOON.png": 1355,
	"./MORE.png": 1356,
	"./MOVR.png": 1357,
	"./MSC.png": 1358,
	"./MSS.png": 1359,
	"./MST.png": 1360,
	"./MTD.svg": 1361,
	"./MULTI.png": 1362,
	"./MUST.png": 1363,
	"./MVLP.png": 1364,
	"./MVX.svg": 1365,
	"./MaticX.svg": 1366,
	"./NABOX.png": 1367,
	"./NAOS.png": 1368,
	"./NCASH.png": 1369,
	"./NEAR.png": 1370,
	"./NETT.png": 1371,
	"./NEXO.png": 1372,
	"./NFT.png": 1373,
	"./NFTY.png": 1374,
	"./NUGGET.svg": 1375,
	"./NUTS.png": 1376,
	"./NYA.png": 1377,
	"./NYAC.png": 1378,
	"./NYAS.png": 1379,
	"./NZDS.png": 1380,
	"./O3.png": 1381,
	"./OASIS.svg": 1382,
	"./OCP.png": 1383,
	"./OLE.png": 1384,
	"./ONE.svg": 1385,
	"./ONG.svg": 1386,
	"./ONT.png": 1387,
	"./OOE.svg": 1388,
	"./OP.svg": 1389,
	"./OPX.svg": 1390,
	"./ORBS.svg": 1391,
	"./ORKAN.png": 1392,
	"./OXD.png": 1393,
	"./PACOCA.svg": 1394,
	"./PAE.svg": 1395,
	"./PAR.png": 1396,
	"./PAUTO.png": 1397,
	"./PBNB.png": 1398,
	"./PEAR.svg": 1399,
	"./PEEL.png": 1400,
	"./PEFI.png": 1401,
	"./PERA.png": 1402,
	"./PERP.webp": 1403,
	"./PETS.png": 1404,
	"./PEX.png": 1405,
	"./PHA.png": 1406,
	"./PILLS.png": 1407,
	"./PMP.svg": 1408,
	"./PNG.png": 1409,
	"./POLYGON.png": 1410,
	"./POOP.png": 1411,
	"./POPS.png": 1412,
	"./PORTO.png": 1413,
	"./POTS.png": 1414,
	"./PSP.png": 1415,
	"./PSTAKE.png": 1416,
	"./PTP.png": 1417,
	"./PUP.png": 1418,
	"./PolyDoge.png": 1419,
	"./QBT.svg": 1420,
	"./QI.png": 1421,
	"./QUICK.png": 1422,
	"./QUIDD.png": 1423,
	"./RABBIT.svg": 1424,
	"./RACA.svg": 1425,
	"./RAMP.png": 1426,
	"./RDNT.svg": 1427,
	"./RELAY.png": 1428,
	"./REVV.svg": 1429,
	"./RIB.png": 1430,
	"./ROME.png": 1431,
	"./ROSE.png": 1432,
	"./ROUTE.png": 1433,
	"./RPG.png": 1434,
	"./SAGE.png": 1435,
	"./SAND.png": 1436,
	"./SANTOS.png": 1437,
	"./SBDO.png": 1438,
	"./SCREAM.png": 1439,
	"./SD.svg": 1440,
	"./SFP.png": 1441,
	"./SFUND.png": 1442,
	"./SHADE.png": 1443,
	"./SHIB.png": 1444,
	"./SHIBX.png": 1445,
	"./SHRAP.png": 1446,
	"./SING.png": 1447,
	"./SISTA.svg": 1448,
	"./SKILL.svg": 1449,
	"./SKY.svg": 1450,
	"./SMART.png": 1451,
	"./SNX.png": 1452,
	"./SOAK.png": 1453,
	"./SOL.png": 1454,
	"./SOLACE.png": 1455,
	"./SOLAR.png": 1456,
	"./SOLID.webp": 1457,
	"./SONNE.png": 1458,
	"./SPADE.png": 1459,
	"./SPELL.png": 1460,
	"./SPIRIT.png": 1461,
	"./SPS.svg": 1462,
	"./STARS.svg": 1463,
	"./START.png": 1464,
	"./STATIC.png": 1465,
	"./STEAK.png": 1466,
	"./STEEL.png": 1467,
	"./STELLA.png": 1468,
	"./STNEAR.png": 1469,
	"./SUMMIT.png": 1470,
	"./SUSHI.png": 1471,
	"./SUSHIe.png": 1472,
	"./SWAMP.svg": 1473,
	"./SX.png": 1474,
	"./SXP.svg": 1475,
	"./SYN.svg": 1476,
	"./TAPE.svg": 1477,
	"./TAROT.png": 1478,
	"./TEL.png": 1479,
	"./TENFI.png": 1480,
	"./TETHYS.svg": 1481,
	"./TETU.svg": 1482,
	"./THALES.png": 1483,
	"./THG.png": 1484,
	"./TIME.png": 1485,
	"./TITAN.svg": 1486,
	"./TKO.png": 1487,
	"./TLM.png": 1488,
	"./TLOS.svg": 1489,
	"./TOMB.png": 1490,
	"./TONIC.svg": 1491,
	"./TOR.svg": 1492,
	"./TREEB.png": 1493,
	"./TRI.svg": 1494,
	"./TRIVIA.png": 1495,
	"./TRX.png": 1496,
	"./TSHARE.svg": 1497,
	"./TUS.png": 1498,
	"./TUSD.png": 1499,
	"./TWT.png": 1500,
	"./TYPH.png": 1501,
	"./UFT.png": 1502,
	"./UNI.png": 1503,
	"./UNIDX.png": 1504,
	"./UNIe.png": 1505,
	"./USD+.png": 1506,
	"./USDB.png": 1507,
	"./USDC.svg": 1508,
	"./USDCe.svg": 1509,
	"./USDCm.svg": 1510,
	"./USDCs.svg": 1511,
	"./USDCwh.svg": 1512,
	"./USDD.png": 1513,
	"./USDL.svg": 1514,
	"./USDO.png": 1515,
	"./USDT.svg": 1516,
	"./USDTe.svg": 1517,
	"./USDTs.svg": 1518,
	"./USDTxc.svg": 1519,
	"./USN.svg": 1520,
	"./UST.png": 1521,
	"./UST_Rose.png": 1522,
	"./USTaxl.png": 1523,
	"./USTw.png": 1524,
	"./USX.svg": 1525,
	"./VALAS.svg": 1526,
	"./VELO.svg": 1527,
	"./VERSA.svg": 1528,
	"./VOLT.png": 1529,
	"./VS.svg": 1530,
	"./VST.svg": 1531,
	"./VTX.png": 1532,
	"./VVS.svg": 1533,
	"./WAN.svg": 1534,
	"./WATCH.png": 1535,
	"./WAULTx.svg": 1536,
	"./WAVAX.png": 1537,
	"./WBNB.png": 1538,
	"./WBNB.svg": 1539,
	"./WBTC.png": 1540,
	"./WBTC.svg": 1541,
	"./WBTCe.svg": 1542,
	"./WBTCeth.svg": 1543,
	"./WBTCwh.svg": 1544,
	"./WCELO.svg": 1545,
	"./WCRO.svg": 1546,
	"./WELL.png": 1547,
	"./WETH.svg": 1548,
	"./WETHe.svg": 1549,
	"./WEX.svg": 1550,
	"./WEXpoly.png": 1551,
	"./WFTM.svg": 1552,
	"./WFUSE.svg": 1553,
	"./WGLMR.png": 1554,
	"./WHT.png": 1555,
	"./WIGO.svg": 1556,
	"./WIN.png": 1557,
	"./WINE.png": 1558,
	"./WINGS.png": 1559,
	"./WKAVA.png": 1560,
	"./WMATIC.svg": 1561,
	"./WMATIC_DFYN.svg": 1562,
	"./WMETIS.svg": 1563,
	"./WMOVR.png": 1564,
	"./WMOVR_SUSHI.png": 1565,
	"./WOM.png": 1566,
	"./WONE.svg": 1567,
	"./WOO.svg": 1568,
	"./WOOP.png": 1569,
	"./WROSE.svg": 1570,
	"./WSG.svg": 1571,
	"./WSTA.png": 1572,
	"./WUSD.svg": 1573,
	"./XAVA.png": 1574,
	"./XCV.svg": 1575,
	"./XRP.png": 1576,
	"./XSGD.png": 1577,
	"./XTZ.png": 1578,
	"./XVS.png": 1579,
	"./XWG.png": 1580,
	"./YAMP.svg": 1581,
	"./YEL.svg": 1582,
	"./YELD.png": 1583,
	"./YETI.png": 1584,
	"./YFI.png": 1585,
	"./YFIe.png": 1586,
	"./YGG.png": 1587,
	"./YOSHI.png": 1588,
	"./YUZU.png": 1589,
	"./ZBTC.svg": 1590,
	"./ZEC.png": 1591,
	"./ZETH.svg": 1592,
	"./ZOO.png": 1593,
	"./aBNBb.png": 1594,
	"./aBNBc.png": 1595,
	"./aQI.png": 1596,
	"./aROME.png": 1597,
	"./aUSDO.svg": 1598,
	"./aWOOL.png": 1599,
	"./agEUR.png": 1600,
	"./alETH.svg": 1601,
	"./alUSD.svg": 1602,
	"./ankrBNB.svg": 1603,
	"./anyMTLX.png": 1604,
	"./asUSDC.png": 1605,
	"./atUST.svg": 1606,
	"./auraBAL.png": 1607,
	"./axlATOM.png": 1608,
	"./bQI.png": 1609,
	"./bZoo.png": 1610,
	"./bb-yv-FTM.png": 1611,
	"./bbDAI+.png": 1612,
	"./bbUSD+.webp": 1613,
	"./bbaDAI.png": 1614,
	"./bbaUSD.png": 1615,
	"./bbaUSDC.png": 1616,
	"./bbaUSDT.png": 1617,
	"./bbamDAI.png": 1618,
	"./bbamUSD.png": 1619,
	"./bbamUSDC.png": 1620,
	"./bbamUSDT.png": 1621,
	"./bbrfaUSD.png": 1622,
	"./bbrfaWBTC.png": 1623,
	"./bbrfaWETH.png": 1624,
	"./beFTM.svg": 1625,
	"./beJOE.png": 1626,
	"./beJOE.svg": 1627,
	"./beOPX.png": 1628,
	"./beQI.png": 1629,
	"./beQI.svg": 1630,
	"./beVELO.svg": 1631,
	"./binSPIRIT.svg": 1632,
	"./bsc/BSHARE.png": 1633,
	"./bscBUSD.svg": 1634,
	"./cEUR.png": 1635,
	"./cUSD.png": 1636,
	"./cakeHARD.png": 1637,
	"./cakeROOBEE.png": 1638,
	"./cakeSTAX.png": 1639,
	"./cakeTWT.png": 1640,
	"./cakebROOBEE.png": 1641,
	"./cbETH.png": 1642,
	"./ceUSDC.svg": 1643,
	"./crvFRAX.svg": 1644,
	"./crvUSDBTCETH3.svg": 1645,
	"./cvxCRV.webp": 1646,
	"./cvxFXS.png": 1647,
	"./cxADA.png": 1648,
	"./cxBTC.png": 1649,
	"./cxDOGE.png": 1650,
	"./cxETH.png": 1651,
	"./ethereum/FXS.png": 1652,
	"./ethereum/alETH.svg": 1653,
	"./ethereum/pETH.png": 1654,
	"./evoBTC.svg": 1655,
	"./evoETH.svg": 1656,
	"./evoUSDC.svg": 1657,
	"./evoUSDT.svg": 1658,
	"./fUSD.png": 1659,
	"./fUSDT.png": 1660,
	"./fWINGS.svg": 1661,
	"./fantom/FUSD.png": 1662,
	"./frxETH.png": 1663,
	"./gALCX.png": 1664,
	"./gOHM.png": 1665,
	"./ibBTC.svg": 1666,
	"./jBRL.svg": 1667,
	"./jCAD.png": 1668,
	"./jCHF.png": 1669,
	"./jEUR.png": 1670,
	"./jGBP.png": 1671,
	"./jJPY.png": 1672,
	"./jNZD.svg": 1673,
	"./jSGD.png": 1674,
	"./mDAI.svg": 1675,
	"./mUSDC.svg": 1676,
	"./mUSDT.svg": 1677,
	"./miMatic.png": 1678,
	"./moSOLID.svg": 1679,
	"./mooBIFI.png": 1680,
	"./multiBTC.webp": 1681,
	"./nUSD.svg": 1682,
	"./newQUICK.svg": 1683,
	"./pAVAX.svg": 1684,
	"./pBNB.svg": 1685,
	"./pBREW.png": 1686,
	"./pCRO.svg": 1687,
	"./pETH.svg": 1688,
	"./pETHo.svg": 1689,
	"./pFTM.svg": 1690,
	"./pMATIC.svg": 1691,
	"./pOPEN.png": 1692,
	"./pOPEN.webp": 1693,
	"./pWINGS.png": 1694,
	"./polyBUNNY.png": 1695,
	"./polyWISE.png": 1696,
	"./polygon/FISH.svg": 1697,
	"./psETH.svg": 1698,
	"./rETH.webp": 1699,
	"./rUSD.svg": 1700,
	"./renBTC.png": 1701,
	"./renBTC.svg": 1702,
	"./renDGB.svg": 1703,
	"./renDOGE.png": 1704,
	"./sALPACA.svg": 1705,
	"./sAVAX.png": 1706,
	"./sBTC.png": 1707,
	"./sCRO.svg": 1708,
	"./sETH.svg": 1709,
	"./sETHo.svg": 1710,
	"./sEUR.png": 1711,
	"./sFTMx.png": 1712,
	"./sSPELL.png": 1713,
	"./sUSD.webp": 1714,
	"./saUSDC.svg": 1715,
	"./saUSDT.svg": 1716,
	"./sarETH.svg": 1717,
	"./sarUSDC.svg": 1718,
	"./sarUSDT.svg": 1719,
	"./sbBUSD.svg": 1720,
	"./sbUSDT.svg": 1721,
	"./sethETH.svg": 1722,
	"./sethUSDC.svg": 1723,
	"./sethUSDT.svg": 1724,
	"./sfUSDC.svg": 1725,
	"./sfrxETH.png": 1726,
	"./soETH.svg": 1727,
	"./soUSDC.svg": 1728,
	"./stDOT.svg": 1729,
	"./stETH.svg": 1730,
	"./stKSM.png": 1731,
	"./stMATIC.png": 1732,
	"./stella4pool.png": 1733,
	"./stkBNB.png": 1734,
	"./wMEMO.png": 1735,
	"./wsHEC.png": 1736,
	"./wsSPA.png": 1737,
	"./wstDOT.svg": 1738,
	"./wstETH.png": 1739,
	"./wstKSM.png": 1740,
	"./xBOO.png": 1741,
	"./xMARK.png": 1742,
	"./xSCREAM.png": 1743,
	"./xVOLT.svg": 1744,
	"./xYELD.svg": 1745,
	"./xcDOT.png": 1746,
	"./xcINTR.png": 1747,
	"./xcKBTC.png": 1748,
	"./xcKSM.png": 1749,
	"./xcRMRK.png": 1750,
	"./xcaUSD.png": 1751,
	"./xciBTC.png": 1752
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1022;